import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Maintenance from "@/views/Maintenance.vue";
import Error403 from "@/views/Error403.vue";
import Error404 from "@/views/Error404.vue";
import Error500 from "@/views/Error500.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        redirect: "/home",
    },
    {
        path: "/home",
        name: "Home",
        meta: {
            menuKeyValue: "1",
            title: "Strona Główna",
        },
        component: Home,
    },
    {
        path: "/form",
        name: "Form",
        meta: {
            menuKeyValue: "99",
            title: "Formularz",
            subtitle: "Wniosek",
        },
        component: () => import(/* webpackChunkName: "Form" */ "../views/Form.vue"),
    },
    {
        path: "/form/status",
        name: "FormStatus",
        meta: {
            menuKeyValue: "99",
            title: "Formularz",
            subtitle: "Wniosek",
        },
        component: () => import(/* webpackChunkName: "Form" */ "../views/Form.vue"),
    },
    {
        path: "/account",
        name: "Account",
        meta: {
            shouldBeLoggedIn: true,
            menuKeyValue: "99",
            title: "Panel użytkownika",
            subtitle: "Urządzenia",
        },
        component: () => import(/* webpackChunkName: "Account" */ "../views/Account.vue"),
    },
    {
        path: "/account/login",
        name: "Login",
        meta: {
            menuKeyValue: "99",
            title: "Panel użytkownika",
            subtitle: "Logowanie",
        },
        component: () => import(/* webpackChunkName: "Login" */ "../views/Login.vue"),
    },
    {
        path: "/account/logout",
        name: "Logout",
        meta: {
            menuKeyValue: "99",
            title: "Panel użytkownika",
            subtitle: "Wylogowanie",
        },
        component: () => import(/* webpackChunkName: "Logout" */ "../views/Logout.vue"),
    },
    {
        path: "/terms",
        name: "Terms",
        meta: {
            menuKeyValue: "2",
            title: "Regulamin",
        },
        component: () =>
            import(/* webpackChunkName: "Terms" */ "../views/Terms.vue"),
    },
    {
        path: "/help",
        name: "Help",
        meta: {
            menuKeyValue: "3",
            title: "Pomoc",
        },
        component: () => import(/* webpackChunkName: "Help" */ "../views/Help.vue"),
    },
    {
        path: "/contact",
        name: "Contact",
        meta: {
            menuKeyValue: "4",
            title: "Kontakt",
        },
        component: () =>
            import(/* webpackChunkName: "Contact" */ "../views/Contact.vue"),
    },
    {
        path: "/contact-form",
        name: "ContactForm",
        meta: {
            menuKeyValue: "4",
            title: "Kontakt",
        },
        component: () =>
            import(/* webpackChunkName: "Contact" */ "../views/ContactForm.vue"),
    },
    {
        path: "/rodo",
        name: "RODO",
        meta: {
            title: "Informacje RODO",
        },
        component: () => import(/* webpackChunkName: "Rodo" */ "../views/Rodo.vue"),
    },
    {
        path: "/credits",
        name: "Credits",
        meta: {
            title: "Wykorzystane oprogramowanie",
        },
        component: () =>
            import(/* webpackChunkName: "Credits" */ "../views/Credits.vue"),
    },
    {
        path: "/maintenance",
        name: "Maintenance",
        meta: {
            menuKeyValue: "1",
            title: "Przerwa techniczna",
        },
        component: Maintenance,
    },
    {
        path: "/error-403",
        name: "Error403",
        meta: {
            menuKeyValue: "1",
            title: "Błąd",
        },
        component: Error403,
    },
    {
        path: "/error",
        name: "Error404",
        meta: {
            menuKeyValue: "1",
            title: "Błąd",
        },
        component: Error404,
    },
    {
        path: "/error-500",
        name: "Error500",
        meta: {
            menuKeyValue: "1",
            title: "Błąd",
        },
        component: Error500,
    },
    {
        path: "*",
        meta: {
            menuKeyValue: "1",
            title: "Błąd",
        },
        redirect: "/error",
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    let isLoggedIn = localStorage.getItem("isLoggedIn") != null ? localStorage.getItem("isLoggedIn") : false
    let shouldBeLoggedIn = to.meta.shouldBeLoggedIn != null ? to.meta.shouldBeLoggedIn : false

    if (!isLoggedIn && shouldBeLoggedIn) {
        next({name: "Error403"})
    } else {
        next()
    }
})

export default router;
